import React from "react";
import "./HomeNewsCard.scss";
import img from "../../../../Assets/Home/img/HomeNews/image 17.png";
import { formatDate } from "../../../../Modules/GeneralModule/GeneralLogic";
import { NavLink } from "react-router-dom";

/*
  Слева главная новость, справа ещё три строкой. Строки времени чтения нет:
  в ответе API read_time — это время создания записи («10:50:13» при
  created_at 10:50:52), а не минуты, и считать их по длине текста мы не
  будем.
*/
const HomeNewsCard = ({ newsData }) => {
  // Пока ответа нет — та же сетка заглушками: иначе блок появляется целиком
  // и двигает подвал.
  if (!newsData || newsData.length === 0) {
    return (
      <div className="homeNewsCard_container" aria-hidden="true">
        <div className="homeNewsCard_main homeNewsCard_main--skeleton">
          <span className="homeNewsCard_ph homeNewsCard_ph--img" />
          <span className="homeNewsCard_ph homeNewsCard_ph--date" />
          <span className="homeNewsCard_ph homeNewsCard_ph--title" />
        </div>
        <div className="homeNewsCard_list">
          {[0, 1, 2].map((i) => (
            <div className="homeNewsCard_row" key={i}>
              <span className="homeNewsCard_ph homeNewsCard_ph--date" />
              <span className="homeNewsCard_ph homeNewsCard_ph--rowTitle" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  const [main, ...rest] = newsData.slice(0, 4);

  return (
    <div className="homeNewsCard_container">
      <NavLink className="homeNewsCard_main" to={`/newsItem/${main?.id}`}>
        <img src={main?.image || img} alt="" />
        <span className="homeNewsCard_date">{formatDate(main?.created_at)}</span>
        <h2 className="homeNewsCard_title">{main?.title}</h2>
      </NavLink>

      <div className="homeNewsCard_list">
        {rest.map((e) => (
          <NavLink key={e.id} className="homeNewsCard_row" to={`/newsItem/${e.id}`}>
            <span className="homeNewsCard_date">{formatDate(e.created_at)}</span>
            <h3 className="homeNewsCard_rowTitle">{e.title}</h3>
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default HomeNewsCard;
